export const numberCheck = (data: string) => {
  const regex = /^[0-9]*$/;
  return regex.test(data);
};
